import { Outlet } from 'react-router-dom';
import { useTheme, SidebarShell } from '@flowcore-water/ui';
import type { NavItem } from '@flowcore-water/ui';

const NAV_ITEMS: NavItem[] = [
  { to: '/', label: 'Entities', icon: '📋' },
  { to: '/search', label: 'Search', icon: '🔍' },
];

function FlowcoreLogo({ theme }: { theme: string }) {
  if (theme === 'retro') {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <img src="/flowcore-retro.png" alt="FLOWCORE" style={{ height: 24, width: 'auto', filter: 'drop-shadow(0 0 8px rgba(5, 217, 232, 0.4))' }} />
      </div>
    );
  }
  if (theme === 'light') {
    return <img src="/flowcore-logo-blue.svg" alt="Flowcore" className="sidebar-shell-logo" />;
  }
  return <img src="/flowcore-logo.svg" alt="Flowcore" className="sidebar-shell-logo" />;
}

function SynthwaveBackground() {
  return (
    <div style={{ position: 'fixed', inset: 0, overflow: 'hidden', pointerEvents: 'none', zIndex: 0 }}>
      <div style={{ position: 'absolute', inset: 0, backgroundImage: 'url(/synthwave.png)', backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }} />
      <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, rgba(13,2,33,0.2) 0%, rgba(13,2,33,0.5) 40%, rgba(13,2,33,0.8) 70%, rgba(13,2,33,0.95) 100%)' }} />
    </div>
  );
}

export function Layout() {
  const { t, theme, setTheme, isRetro } = useTheme();

  return (
    <SidebarShell
      theme={t}
      appSlug="mirror"
      appTitle="ST Mirror"
      navItems={NAV_ITEMS}
      logo={<FlowcoreLogo theme={theme} />}
      themeName={theme}
      onThemeChange={setTheme}
      background={isRetro ? <SynthwaveBackground /> : undefined}
    >
      <Outlet />
    </SidebarShell>
  );
}
